<template>
  <hm-content title="">
    <div class="act-step-wrapper">
      <hm-step
        :steps="steps"
        :scroll="true"
        :step="currentStep"
        @scroll="windowScroll"
      ></hm-step>
    </div>
    <div class="p30">
      <div class="type-list flex flex-wrap">
        <div
          class="item"
          v-for="(v, i) in typeList"
          :key="i"
          @click="toUrl(v.url, v.gameType)"
        >
          <div class="title">{{ v.title }}</div>
          <div class="subTitle">{{ v.subTitle }}</div>
          <div class="btn">新建活码></div>
        </div>
      </div>

      <div class="flex flex-center mt100">
        <el-button size="small" @click="$router.back(-1)">返回 </el-button>
      </div>
    </div>
  </hm-content>
</template>
<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {
    HmStep,
  },
  data() {
    return {
      steps: [
        {
          id: "IntelligentCodeType",
          name: "选择活码类型",
        },
        {
          id: "IntelligentCodeDetail",
          name: "配置活码内容",
        },
        {
          id: "over",
          name: "设置完成",
        },
      ],
      currentStep: 1,
      typeList: [
        {
          title: "门店活码",
          subTitle: "根据定位有限推最近门店的二维码",
          url: "IntelligentCodeDetail",
          gameType: "qr_code_shop",
        },
        // {
        //   title: "同城同龄码",
        //   subTitle: "根据用户的孕育和地区推荐二维码",
        //   url: "IntelligentCodeDetail",
        // },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toUrl(name, gameType) {
      this.$router.push({
        name,
        query: {
          gameType,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.p30 {
  padding: 30px;
}
.type-list {
  .item {
    width: 330px;
    padding: 30px;
    background: #eeeeee;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    cursor: pointer;
    .title {
      font-size: 18px;
      color: #222222;
      line-height: 21px;
      font-weight: bold;
    }
    .subTitle {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      height: 72px;
      overflow: hidden;
    }
    .btn {
      font-size: 14px;
      color: #e50065;
      line-height: 16px;
    }
  }
}
.mt100{
  margin-top: 100px;
}
</style>